/** JSON equality without serialization. Key order is part of the layer contract. */
export function sameJson(left: unknown, right: unknown, omit?: (key: string) => boolean): boolean {
    if (Object.is(left, right)) return true;
    if (!left || !right || typeof left !== 'object' || typeof right !== 'object' || Array.isArray(left) !== Array.isArray(right)) return false;
    if (Array.isArray(left) && left.length !== (right as unknown[]).length) return false;
    const keys = Object.keys(left).filter(key => !omit?.(key)), other = Object.keys(right).filter(key => !omit?.(key));
    return keys.length === other.length && keys.every((key, index) => key === other[index]
        && sameJson((left as Record<string, unknown>)[key], (right as Record<string, unknown>)[key], omit));
}
